import React from 'react';

export default function ParkingIcon({
  width = 48,
  height = 48,
  fill = '#9F9FA0',
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_10015_20299)">
        <path
          d="M22.5642 27.7313V34.4756C22.5642 34.5395 22.292 35.0865 22.223 35.1875C21.065 36.8809 18.6009 36.2266 18.284 34.2596L18.2559 15.9131C18.3147 14.8447 19.0802 14.0881 20.1346 13.9654C22.453 13.697 27.716 13.8797 29.8593 14.7437C33.7638 16.317 34.4655 22.2076 32.1138 25.2762C30.0178 28.0112 25.6392 27.6585 22.5629 27.7326L22.5642 27.7313ZM22.5642 24.0007H26.1517C26.4099 24.0007 27.2649 23.7757 27.5384 23.6645C29.3481 22.9335 29.6485 19.5006 28.1608 18.3568C27.7608 18.0488 26.4418 17.5912 25.9613 17.5912H22.5655V24.0007H22.5642Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3ZM0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_10015_20299">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
